import { isNodeWithChildren } from './isNodeWithChildren';

export const findTextNodes = (
  node: BaseNode,
  skipNodeIds: string[] = []
): TextNode[] => {
  if (!isNodeWithChildren(node)) return [];
  const textNodes: TextNode[] = node.findAll(
    (node) => !skipNodeIds.includes(node.id) && node.type === 'TEXT'
  ) as TextNode[];

  return textNodes;
};
